export const ClipboardMenu = (function () {
  let el = document.createElement('div');
  el.className = 'bubble-menu';
  el.innerHTML = '';
  el.addEventListener('click', () => {
    controller.hide();
  });

  let style = document.createElement('style');
  style.innerHTML = `
      .bubble-menu {
        display: none; position: absolute; top: 0; left: 0;
        white-space: nowrap; border-radius: .1rem;
        font-size: 12px; color: #fff; background-color: rgba(0,0,0,.7);
        transform: translate(-50%, -3em);
        z-index: 99;
      }
      .bubble-menu::after {
        content: ''; position: absolute; left: 50%; top: 100%;
        width: 0; height: 0;
        border-top: 8px solid rgba(0,0,0,.7);
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        transform: translate3d(-50%, 0, 0);
      }
      .bubble-menu span {
        position: relative;
        display: inline-block;
        padding: 6px 2em;
      }
      .bubble-menu span::after {
        content: '|';
        position: absolute;
        right: -6px;
      }
      .bubble-menu span:last-child::after {
        content: '';
      }`;
  document.body.appendChild(style);
  document.body.appendChild(el);

  let controller = {
    el,
    isShow: false,
    show(params) {
      let left = params.left || 0;
      let top = params.top || 0;
      let items = params.items || [];

      let _html = '';
      items.forEach(item => {
        _html += `<span class="clipboard-trigger" data-key="${item.key}">${item.name}</span>`;
      });

      el.innerHTML = _html;
      el.style.left = Math.round(left) + 'px';
      el.style.top = Math.round(top) + 'px';
      el.style.display = 'block';
      this.isShow = true;
    },
    hide() {
      el.style.display = 'none';
      this.isShow = false;
    }
  };

  return controller;
})();



// WEBPACK FOOTER //
// ./src/components/Poi2/ClipboardMenu.js